import * as React from 'react'
import { IPayment } from '@getgreenline/homi-shared'
import { CustomerReceiptModal } from '../../containers/CustomerReceiptModal'
import { BlazeButton } from '../CustomButtons/BlazeButton'
import { LoyaltyModels } from '@getgreenline/loyalties'

interface Props {
  payment: IPayment
  loyaltyData?: LoyaltyModels.ILoyaltyData
  paymentOptionNames?: { [key: number]: string }
}

interface State {
  showReceiptModal: boolean
}

export class ViewReceiptButton extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      showReceiptModal: false,
    }
  }

  render() {
    const { payment, loyaltyData, paymentOptionNames } = this.props
    return (
      <>
        <BlazeButton
          buttonProps={{
            type: 'default',
            size: 'large',
            onClick: () => this.setState({ showReceiptModal: true }),
          }}
          titleProps={{
            title: 'View receipt',
          }}
        />
        {this.state.showReceiptModal ? (
          <CustomerReceiptModal
            payment={payment}
            onHide={() => this.setState({ showReceiptModal: false })}
            loyaltyData={loyaltyData}
            paymentOptionNames={paymentOptionNames}
          />
        ) : undefined}
      </>
    )
  }
}
